import tinycolor from "tinycolor2";

/**
 * Adjusts the luminance of a color (perceptual luminance and not lightness)
 * @param {string} color
 * @param {number} targetLuminance target relative luminance (0–1)
 * @returns {object} tinycolor instance with the adjusted color
 */
export function adjustLuminance(color, targetLuminance) {
    color = tinycolor(color);
    const hsl = color.toHsl();

    let low = 0, high = 1;
    for (let i = 0; i < 20; i++) {
        const mid = (low + high) / 2;
        const lum = getRelativeLuminance(tinycolor({ h: hsl.h, s: hsl.s, l: mid }));
        if (lum < targetLuminance) {
            low = mid;
        } else {
            high = mid;
        }
    }

    return tinycolor({ h: hsl.h, s: hsl.s, l: (low + high) / 2 });
}

function getRelativeLuminance(color) {
    const { r, g, b } = color.toRgb();
    const linearize = c => {
        c /= 255;
        return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b);
}